import messages from '@otovo/shared/components/Sanity/SanityFAQAccordion/messages';
import { useSanityFAQs } from '@otovo/shared/components/Sanity/SanityFAQAccordion/useSanityFAQs';
import { FormattedMessage as T } from 'react-intl';
import SectionWrapper from '../../SectionWrapper';
import FAQItem from './FAQItem';

const FAQ = () => {
  const data = useSanityFAQs();
  if (!data) {
    return null;
  }
  return (
    <SectionWrapper gap="gap-4">
      <h2
        className="col-span-full mb-6 text-2xl font-semibold text-balance break-words text-heading md:text-3xl lg:mr-16 lg:text-4xl"
        data-testid="sanity-faq-storefront"
      >
        <T {...messages.heading} />
      </h2>
      {data.map((question) => (
        <div
          key={`accordion-item-${question.title}`}
          className="col-span-6 mb-4 lg:mb-0"
        >
          <FAQItem question={question} />
        </div>
      ))}
    </SectionWrapper>
  );
};

export default FAQ;
